import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Order } from '@features/orders/models/order.model';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { OrderAPIService } from '@features/orders/services/order-api.service';
import { isDefined } from '@shared/utils/is-defined.util';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { OrderLineStatus } from '@shared-features/enums/order-line-status.enum';

@Component({
  selector: 'app-orders-list-timeline',
  templateUrl: './orders-list-timeline.component.html',
  styleUrls: ['./orders-list-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'madar--v2 list-timeline',
  },
})
export class OrdersListTimelineComponent extends BaseComponent {
  @Input() city: string;
  @Input() location: string;
  @Input() gate: string;
  @Input() checkInDate: Date;

  @Input() totalCapacity: number;
  @Input() consumedCapacity: number;

  @Input() orders: Order[];
  @Input() shipmentId?: number;

  @Input() timeline = true;
  @Input() readonly: boolean;
  @Input() showOrderType = false;
  @Input() sortable = false;
  @Input() actionIcon: string;

  @Output() dropOrder = new EventEmitter<CdkDragDrop<any, any>>();
  @Output() handelRemoveStaged = new EventEmitter();

  constructor(
    private orderAPIService: OrderAPIService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  getOrderPallets(order: Order) {
    if (!order.pallets?.length && order.isPalletDetails) {
      this.load(
        this.orderAPIService.getPalletList({
          orderId: order.id,
          isForCreation: !isDefined(this.shipmentId),
          shipmentId: this.shipmentId,
        })
      ).subscribe((pallets) => {
        order.pallets = pallets;
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  handelRemoveOrder(order) {
    this.handelRemoveStaged.emit(order);
  }
  protected readonly OrderLineStatus = OrderLineStatus;
}
